module.exports = __webpack_public_path__ + "static/media/HCRA Freeze Orders - Lynphyl Homes Ltd. - June 18, 2024.0c3c296a.pdf";